import {useSelector} from "react-redux";
import React, {useState} from "react";
import axios from "axios";
import {toast} from "react-toastify";
import {Button, Modal, Spinner} from "react-bootstrap";

const DeliveryOutcomeReturnModal = ({show, setShow, qrUrls, successCallback}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [loading, setLoading] = useState(false);

    const onAccept = () => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/sale/confirm-delivery-return-outcome`, {
            qrUrls,
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                if (res.data.errors) {
                    for (const err of res.data.errors) {
                        toast.error(err);
                    }
                }
                const successCount = qrUrls.length - res.data.errors.length;
                if (successCount > 0) toast.success(`Επιτυχής ολοκλήρωση ${successCount} Δ.Α.`);
                setShow(false);
                if (successCallback) successCallback();
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <Modal show={show} onHide={() => setShow(false)} backdrop={"static"} dialogClassName={"modal42PercentWidth"}>
            <Modal.Header closeButton>
                <Modal.Title>Ολοκλήρωση Διακίνησης Επιστροφής</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Είσαστε σίγουροι ότι θέλετε να ολοκληρώσετε {qrUrls.length > 1 ? "τις διακινήσεις επιστροφής" : "την διακίνηση επιστροφής"};
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={() => setShow(false)} disabled={loading}>
                    Όχι, κλείσιμο
                </Button>
                <Button variant="primary" onClick={() => onAccept()} disabled={loading}>
                    Ναι, ολοκλήρωση {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DeliveryOutcomeReturnModal;
